import { AdminSystemUser, RolePermissionConfig, PermissionRowDef, PermissionActionKey } from '../types';

// Tab 1: การจัดการทะเบียนลูกบ้าน - Exact 6 Sections & 32 Rows from Images 3, 4, 5, 6
export const ESTATE_MGMT_PERMISSION_ROWS: PermissionRowDef[] = [
  // หมวด: ตั้งค่าอื่นๆ (Image 3)
  { id: 'note_invoice', category: 'ตั้งค่าอื่นๆ', name: 'ตั้งค่าหมายเหตุการออกใบแจ้งหนี้' },
  { id: 'note_receipt', category: 'ตั้งค่าอื่นๆ', name: 'ตั้งค่าหมายเหตุใบเสร็จรับเงิน' },
  { id: 'cfg_project', category: 'ตั้งค่าอื่นๆ', name: 'ตั้งค่าข้อมูลโครงการ' },
  { id: 'cfg_committee', category: 'ตั้งค่าอื่นๆ', name: 'ตั้งค่าคณะกรรมการ' },
  { id: 'cfg_dev', category: 'ตั้งค่าอื่นๆ', name: 'ตั้งค่าสำหรับผู้พัฒนาโครงการ' },
  { id: 'cfg_debtor_gateway', category: 'ตั้งค่าอื่นๆ', name: 'ตั้งค่าลูกหนี้เพย์เมนท์เกตเวย์' },

  // หมวด: สำหรับผู้พัฒนาโครงการ (Image 3 & 4)
  { id: 'dev_unit_sales', category: 'สำหรับผู้พัฒนาโครงการ', name: 'สถานะยูนิตขาย' },
  { id: 'dev_accum_bill_report', category: 'สำหรับผู้พัฒนาโครงการ', name: 'รายงานยูนิตสะสมทนเรียกเก็บ' },
  { id: 'dev_revenue_contract', category: 'สำหรับผู้พัฒนาโครงการ', name: 'สัญญารายรับ' },
  { id: 'dev_general_info', category: 'สำหรับผู้พัฒนาโครงการ', name: 'ข้อมูลทั่วไป' },

  // หมวด: ข้อมูลโครงการ (Image 4)
  { id: 'proj_details', category: 'ข้อมูลโครงการ', name: 'รายละเอียดโครงการ' },
  { id: 'proj_phonebook', category: 'ข้อมูลโครงการ', name: 'สมุดโทรศัพท์' },
  { id: 'proj_committee', category: 'ข้อมูลโครงการ', name: 'คณะกรรมการ' },
  { id: 'proj_juristic_mgr', category: 'ข้อมูลโครงการ', name: 'ผู้จัดการนิติบุคคล' },
  { id: 'proj_bylaws', category: 'ข้อมูลโครงการ', name: 'ข้อบังคับ' },
  { id: 'proj_mgmt_company', category: 'ข้อมูลโครงการ', name: 'บริษัทบริหารนิติบุคคล' },
  { id: 'proj_related_staff', category: 'ข้อมูลโครงการ', name: 'บุคลากรที่เกี่ยวข้อง' },

  // หมวด: ทะเบียนลูกบ้าน (Image 4 & 5)
  { id: 'res_registry', category: 'ทะเบียนลูกบ้าน', name: 'ทะเบียนลูกบ้าน' },
  { id: 'res_vehicles', category: 'ทะเบียนลูกบ้าน', name: 'ยานพาหนะ' },
  { id: 'res_keycards', category: 'ทะเบียนลูกบ้าน', name: 'คีย์การ์ด' },
  { id: 'res_pets', category: 'ทะเบียนลูกบ้าน', name: 'สัตว์เลี้ยง' },
  { id: 'res_ownership', category: 'ทะเบียนลูกบ้าน', name: 'กรรมสิทธิ์' },

  // หมวด: งานลูกบ้าน (Image 5 & 6)
  { id: 'work_news', category: 'งานลูกบ้าน', name: 'ข่าวประชาสัมพันธ์' },
  { id: 'work_surveys', category: 'งานลูกบ้าน', name: 'แบบสอบถาม' },
  { id: 'work_parcels', category: 'งานลูกบ้าน', name: 'จดหมายและพัสดุ' },
  { id: 'work_complaints', category: 'งานลูกบ้าน', name: 'ร้องเรียน' },
  { id: 'work_repairs_legacy', category: 'งานลูกบ้าน', name: 'แจ้งซ่อม (เก่า)' },
  { id: 'work_repairs', category: 'งานลูกบ้าน', name: 'แจ้งซ่อม' },

  // หมวด: พื้นที่ส่วนกลาง (Image 6)
  { id: 'fac_booking_summary', category: 'พื้นที่ส่วนกลาง', name: 'สรุปตารางการจอง' },
  { id: 'fac_booking_list', category: 'พื้นที่ส่วนกลาง', name: 'รายการจองพื้นที่ส่วนกลาง' },
  { id: 'fac_amenities_list', category: 'พื้นที่ส่วนกลาง', name: 'รายการพื้นที่ส่วนกลาง' },
  { id: 'fac_booking_settings', category: 'พื้นที่ส่วนกลาง', name: 'ตั้งค่าการจอง' },
];

// Tab 2: บัญชีและการเงิน
export const ACCOUNTING_PERMISSION_ROWS: PermissionRowDef[] = [
  { id: 'acc_invoices', category: 'ใบแจ้งหนี้ & เรียกเก็บ', name: 'รายการใบแจ้งหนี้ค่าส่วนกลาง' },
  { id: 'acc_receipts', category: 'ใบเสร็จรับเงิน', name: 'รายการใบเสร็จรับเงิน (E-Receipt)' },
  { id: 'acc_slip_check', category: 'การรับชำระเงิน', name: 'ตรวจสอบสลิปโอนเงินธนาคาร' },
  { id: 'acc_debt_free', category: 'เอกสารปลอดหนี้', name: 'ออกหนังสือรับรองปลอดหนี้' },
  { id: 'acc_overdue', category: 'หนี้ค้างชำระ', name: 'รายงานลูกหนี้ค้างชำระ & เบี้ยปรับ' },
  { id: 'acc_expenses', category: 'รายจ่ายนิติบุคคล', name: 'บันทึกค่าใช้จ่าย & ใบสำคัญจ่าย' },
  { id: 'acc_petty_cash', category: 'เงินสดย่อย', name: 'บัญชีเงินสดย่อยสำนักงาน' },
  { id: 'acc_financial_stmt', category: 'งบการเงิน', name: 'งบดุลและงบรายรับ-รายจ่าย' },
  { id: 'acc_tax_withholding', category: 'ภาษีหัก ณ ที่จ่าย', name: 'แบบยื่นภาษี ภ.ง.ด. 3, 53' },
  { id: 'acc_bank_recon', category: 'บัญชีธนาคาร', name: 'รายงานกระทบยอดเงินฝากธนาคาร' },
];

// Tab 3: ซิลเวอร์แมน การ์ด (Silverman Card / งาน รปภ)
export const SECURITY_PERMISSION_ROWS: PermissionRowDef[] = [
  { id: 'sec_visitor_log', category: 'ระบบผู้มาติดต่อ', name: 'บันทึกผู้มาติดต่อ / แลกบัตรเข้า-ออก' },
  { id: 'sec_lpr_barrier', category: 'ไม้กั้นและกล้อง LPR', name: 'ระบบสแกนป้ายทะเบียน & สั่งเปิดไม้กั้น' },
  { id: 'sec_patrol_qr', category: 'การลาดตระเวน', name: 'จุดตรวจ QR Code ลาดตระเวน รปภ.' },
  { id: 'sec_incident_report', category: 'เหตุการณ์ฉุกเฉิน', name: 'บันทึกรายงานเหตุการณ์ผิดปกติ' },
  { id: 'sec_guard_schedule', category: 'ตารางเวร', name: 'ตารางเข้าเวรและผลัด รปภ.' },
  { id: 'card_rfid_mgmt', category: 'ระบบคีย์การ์ด RFID', name: 'ทะเบียนบัตร RFID / Bluetooth EasyPass' },
  { id: 'card_issue_block', category: 'ระบบคีย์การ์ด RFID', name: 'ออกบัตรใหม่ / อายัดบัตรสูญหาย' },
  { id: 'card_access_history', category: 'ประวัติการเข้า-ออก', name: 'รายงานประวัติการแตะบัตรผ่านประตู' },
];

// Helper to create empty actions map
export const createDefaultActions = (enabledActions?: Partial<Record<PermissionActionKey, boolean>>): Record<PermissionActionKey, boolean> => ({
  view: enabledActions?.view ?? false,
  create: enabledActions?.create ?? false,
  edit: enabledActions?.edit ?? false,
  approve: enabledActions?.approve ?? false,
  print: enabledActions?.print ?? false,
  cancel: enabledActions?.cancel ?? false,
});

// Helper to build initial permission map for a role
export const buildInitialEstatePermissions = (allEnabled = false) => {
  const result: Record<string, Record<PermissionActionKey, boolean>> = {};
  ESTATE_MGMT_PERMISSION_ROWS.forEach((r) => {
    result[r.id] = createDefaultActions({
      view: allEnabled,
      create: allEnabled,
      edit: allEnabled,
      approve: allEnabled,
      print: allEnabled,
      cancel: allEnabled,
    });
  });
  return result;
};

export const buildInitialAccountingPermissions = (allEnabled = false) => {
  const result: Record<string, Record<PermissionActionKey, boolean>> = {};
  ACCOUNTING_PERMISSION_ROWS.forEach((r) => {
    result[r.id] = createDefaultActions({
      view: allEnabled,
      create: allEnabled,
      edit: allEnabled,
      approve: allEnabled,
      print: allEnabled,
      cancel: allEnabled,
    });
  });
  return result;
};

export const buildInitialSecurityPermissions = (allEnabled = false) => {
  const result: Record<string, Record<PermissionActionKey, boolean>> = {};
  SECURITY_PERMISSION_ROWS.forEach((r) => {
    result[r.id] = createDefaultActions({
      view: allEnabled,
      create: allEnabled,
      edit: allEnabled,
      approve: allEnabled,
      print: allEnabled,
      cancel: allEnabled,
    });
  });
  return result;
};

// Initial Roles Matching Image 2
export const INITIAL_ROLE_PERMISSIONS: RolePermissionConfig[] = [
  {
    id: 'role-pm',
    role_name: 'PM',
    description: 'ผู้จัดการโครงการและผู้อำนวยการนิติบุคคล (Full Access)',
    permissions: {
      estate_mgmt: buildInitialEstatePermissions(true),
      accounting: buildInitialAccountingPermissions(true),
      security: buildInitialSecurityPermissions(true),
    },
  },
  {
    id: 'role-team1',
    role_name: 'ทีม 1',
    description: 'ทีมปฏิบัติการและประสานงานทั่วไป',
    permissions: {
      estate_mgmt: (() => {
        const p = buildInitialEstatePermissions(false);
        p['res_registry'] = { view: true, create: true, edit: true, approve: false, print: true, cancel: false };
        p['work_news'] = { view: true, create: true, edit: true, approve: false, print: false, cancel: false };
        p['work_parcels'] = { view: true, create: true, edit: true, approve: true, print: true, cancel: false };
        p['work_complaints'] = { view: true, create: true, edit: true, approve: false, print: false, cancel: false };
        return p;
      })(),
      accounting: buildInitialAccountingPermissions(false),
      security: buildInitialSecurityPermissions(false),
    },
  },
  {
    id: 'role-acct',
    role_name: 'บัญชี',
    description: 'เจ้าหน้าที่การเงินและบัญชีนิติบุคคล',
    permissions: {
      estate_mgmt: (() => {
        const p = buildInitialEstatePermissions(false);
        p['res_registry'] = { view: true, create: true, edit: true, approve: false, print: true, cancel: true };
        p['res_vehicles'] = { view: true, create: true, edit: true, approve: false, print: false, cancel: false };
        p['note_invoice'] = { view: true, create: true, edit: true, approve: true, print: true, cancel: false };
        p['note_receipt'] = { view: true, create: true, edit: true, approve: true, print: true, cancel: false };
        return p;
      })(),
      accounting: buildInitialAccountingPermissions(true),
      security: buildInitialSecurityPermissions(false),
    },
  },
  {
    id: 'role-test',
    role_name: 'เทส',
    description: 'บัญชีทดสอบระบบสิทธิ์',
    permissions: {
      estate_mgmt: buildInitialEstatePermissions(false),
      accounting: buildInitialAccountingPermissions(false),
      security: buildInitialSecurityPermissions(false),
    },
  },
  {
    id: 'role-ss',
    role_name: 'ss',
    description: 'เจ้าหน้าที่บริการลูกค้าพิเศษ (Support Specialist)',
    permissions: {
      estate_mgmt: buildInitialEstatePermissions(false),
      accounting: buildInitialAccountingPermissions(false),
      security: buildInitialSecurityPermissions(false),
    },
  },
  {
    id: 'role-ac',
    role_name: 'ac',
    description: 'ผู้ช่วยฝ่ายบัญชี (Accounting Assistant)',
    permissions: {
      estate_mgmt: buildInitialEstatePermissions(false),
      accounting: buildInitialAccountingPermissions(true),
      security: buildInitialSecurityPermissions(false),
    },
  },
  {
    id: 'role-supervisor',
    role_name: 'หัวหน้างาน',
    description: 'หัวหน้าฝ่ายนิติบุคคลและบริหารชุมชน',
    permissions: {
      estate_mgmt: buildInitialEstatePermissions(true),
      accounting: buildInitialAccountingPermissions(false),
      security: buildInitialSecurityPermissions(true),
    },
  },
  {
    id: 'role-ba',
    role_name: 'BA',
    description: 'นักวิเคราะห์ระบบและประสานงาน (Business Analyst)',
    permissions: {
      estate_mgmt: buildInitialEstatePermissions(false),
      accounting: buildInitialAccountingPermissions(false),
      security: buildInitialSecurityPermissions(false),
    },
  },
  {
    id: 'role-ar',
    role_name: 'บัญชีลูกหนี้',
    description: 'เจ้าหน้าที่ติดตามลูกหนี้และออกใบเตือนค้างชำระ',
    permissions: {
      estate_mgmt: (() => {
        const p = buildInitialEstatePermissions(false);
        p['res_registry'] = { view: true, create: false, edit: false, approve: false, print: true, cancel: false };
        p['note_invoice'] = { view: true, create: true, edit: true, approve: false, print: true, cancel: false };
        return p;
      })(),
      accounting: buildInitialAccountingPermissions(true),
      security: buildInitialSecurityPermissions(false),
    },
  },
  {
    id: 'role-accountant-officer',
    role_name: 'เจ้าหน้าที่บัญชี',
    description: 'เจ้าหน้าที่การเงินและตรวจสอบสลิป',
    permissions: {
      estate_mgmt: (() => {
        const p = buildInitialEstatePermissions(false);
        p['res_registry'] = { view: true, create: true, edit: true, approve: false, print: true, cancel: true };
        p['res_vehicles'] = { view: true, create: true, edit: true, approve: false, print: false, cancel: false };
        p['note_invoice'] = { view: true, create: false, edit: true, approve: false, print: true, cancel: false };
        p['note_receipt'] = { view: true, create: false, edit: true, approve: false, print: true, cancel: false };
        return p;
      })(),
      accounting: buildInitialAccountingPermissions(true),
      security: buildInitialSecurityPermissions(false),
    },
  },
  {
    id: 'role-security-guard',
    role_name: 'รปภ. หัวหน้ากะ',
    description: 'เจ้าหน้าที่รักษาความปลอดภัยและสแกนตรวจจุด',
    permissions: {
      estate_mgmt: (() => {
        const p = buildInitialEstatePermissions(false);
        p['res_vehicles'] = { view: true, create: false, edit: false, approve: false, print: false, cancel: false };
        p['res_keycards'] = { view: true, create: false, edit: false, approve: false, print: false, cancel: false };
        p['work_parcels'] = { view: true, create: true, edit: true, approve: true, print: true, cancel: false };
        return p;
      })(),
      accounting: buildInitialAccountingPermissions(false),
      security: buildInitialSecurityPermissions(true),
    },
  },
];

// Initial Users matching Image 1 & 2
export const INITIAL_SYSTEM_USERS: AdminSystemUser[] = [
  {
    id: 'user-0',
    first_name: 'silverman',
    last_name: 'admin',
    full_name: 'silverman admin',
    position: 'admin',
    username: 'silverman03',
    password: '••••',
    last_online: '-',
    avatar_url: '',
    phone: '081-000-0000',
    email: 'admin@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-1',
    full_name: 'lungyam2 123',
    position: 'lungyam2',
    username: 'lungyam2',
    last_online: '29/03/2024 - 08:16 น.',
    avatar_url: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=faces',
    phone: '081-234-5678',
    email: 'lungyam2@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-2',
    full_name: 'adisorntestniti11 adisorntestniti11',
    position: 'adisorntestniti11',
    username: 'adisorntestniti11',
    last_online: '12/03/2024 - 16:55 น.',
    avatar_url: '',
    phone: '089-112-3344',
    email: 'adisorn11@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-3',
    full_name: 'kwan kk',
    position: 'คนสวย',
    username: 'ilovekwan',
    last_online: '07/03/2024 - 22:32 น.',
    avatar_url: '',
    phone: '086-555-7788',
    email: 'kwan@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-4',
    full_name: 'ปิง ปิง',
    position: 'ปิง',
    username: 'pingtestnoti',
    last_online: '08/02/2024 - 14:16 น.',
    avatar_url: '',
    phone: '083-999-1122',
    email: 'ping@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-5',
    full_name: '123 123',
    position: '123',
    username: 'permission-test2',
    last_online: '17/02/2024 - 14:21 น.',
    avatar_url: '',
    phone: '084-222-3333',
    email: 'test123@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-6',
    full_name: 'permission1 permission1',
    position: 'tester',
    username: 'permission-test1',
    last_online: '-',
    avatar_url: '',
    phone: '085-333-4444',
    email: 'perm1@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-7',
    full_name: 'adisorntest2024 dev',
    position: 'dev',
    username: 'adisorntest2024',
    last_online: '12/02/2024 - 12:16 น.',
    avatar_url: '',
    phone: '088-777-6655',
    email: 'adisorndev@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-8',
    full_name: 'คุณศศิธร สุขสมบูรณ์',
    position: 'PM',
    username: 'juristic_mgr',
    last_online: '16/08/2026 - 12:05 น.',
    avatar_url: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&crop=faces',
    phone: '035-998-112',
    email: 'sasithorn@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-9',
    full_name: 'คุณนภาลัย ชัยชนะ',
    position: 'เจ้าหน้าที่บัญชี',
    username: 'acct_napalai',
    last_online: '16/08/2026 - 10:45 น.',
    avatar_url: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=faces',
    phone: '082-111-2233',
    email: 'napalai.c@narawadee.com',
    status: 'active',
  },
  {
    id: 'user-10',
    full_name: 'รปภ. สมศักดิ์ มั่งมี',
    position: 'รปภ. หัวหน้ากะ',
    username: 'somsak_guard',
    last_online: '16/08/2026 - 11:20 น.',
    avatar_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=faces',
    phone: '089-999-8888',
    email: 'somsak.guard@narawadee.com',
    status: 'active',
  },
];
